
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlR as ObiOwnShipControlRElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-r.js';
 
 
 

 
 export const ObiOwnShipControlR = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-r',
   elementClass: ObiOwnShipControlRElement,
   events: {
     
   }
  });
 
 